<template>
  <v-dialog v-model="dialog" max-width="960">
    <template #activator="{on}">
        <slot name="activator" :on="on">
            <v-btn icon v-on="on">
                <v-icon>mdi-clipboard-arrow-left</v-icon>
            </v-btn>
        </slot>
    </template>
    <v-card :disabled="loading" :loading="loading">
        <v-card-title>Return products to Pending Box</v-card-title>
        <v-card-text>
            <v-alert border="bottom" elevation="10" type="warning" dark>Reminder: Move really a product to Pending Box to be keep a correct tracking of product</v-alert>
            <v-text-field
                v-model="quantity"
                :label="'Number of product (' + item.product.name + ') you want return'"
                :hint="'Maximum: ' + maximumItemCanBeReturned "
                type="number"
                :max="maximumItemCanBeReturned"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=false">
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn @click="doReturnToPendingBox" color="orange" dark>
                Return to pending box
            </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'HandlingDialogReturnToPendingBox',
    props: {
        item: {
            type:Object,
            required: true
        }
    },
    data: () => ({
        dialog: false,
        quantity: null
    }),
    computed : {
        ...mapGetters('handling', ['loading']),
        maximumItemCanBeReturned () {
            return this.item.quantity-this.item.built
        }
    },
    methods: {
        ...mapActions('handling', { returnProductToPendingBox : 'returnProductToPendingBox'}),
        doClose(){
            this.dialog=false
            this.quantity=null
        },
        doReturnToPendingBox () {
            if(this.quantity && this.quantity <= this.maximumItemCanBeReturned) {
                this.returnProductToPendingBox({
                    id: this.item.id,
                    quantityToReturn : this.quantity
                }).then(() => {
                    this.doClose()
                    this.$emit('update');
                })
            }
        }
    }
}
</script>

<style>

</style>